<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.5 8.68189C2.5 6.01719 2.5 4.68487 2.8146 4.23664C3.12919 3.78842 4.38193 3.3596 6.88742 2.50196L7.36477 2.33857C8.67083 1.8915 9.32383 1.66797 10 1.66797C10.6762 1.66797 11.3292 1.8915 12.6353 2.33857L13.1126 2.50196C15.6181 3.3596 16.8708 3.78842 17.1854 4.23664C17.5 4.68487 17.5 6.01719 17.5 8.68189V9.99413C17.5 14.6925 13.9675 16.9726 11.7512 17.9407C11.15 18.2033 10.8494 18.3346 10 18.3346C9.15058 18.3346 8.85 18.2033 8.2488 17.9407C6.03247 16.9726 2.5 14.6925 2.5 9.99413V8.68189ZM11.6667 7.5013C11.6667 8.4218 10.9205 9.16797 10 9.16797C9.0795 9.16797 8.33333 8.4218 8.33333 7.5013C8.33333 6.58083 9.0795 5.83464 10 5.83464C10.9205 5.83464 11.6667 6.58083 11.6667 7.5013ZM10 14.168C13.3333 14.168 13.3333 13.4218 13.3333 12.5013C13.3333 11.5808 11.8409 10.8346 10 10.8346C8.15905 10.8346 6.66667 11.5808 6.66667 12.5013C6.66667 13.4218 6.66667 14.168 10 14.168Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'UserManagementIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>